<template>
  <div
    :class="inputBoxClasses"
    :style="wrapperStyle"
    @click="focusElement"
  >
    <div
      v-if="imagesLeft.length"
      :class="[$style.images_left]"
    >
      <div
        v-for="(image, index) in imagesLeft"
        :key="index"
        :class="[$style.image_wrap]"
      >
        <img
          :src="image"
          alt="image"
        >
      </div>
    </div>
    <div
      v-if="iconsLeft.length"
      :class="[$style.icons_left]"
    >
      <!-- <vgp-icon-button
        v-for="(item, i) in iconsLeft"
        :key="i"
        size="small"
        :type="item.buttonType || 'simple'"
        :icon="{ name: item.name || 'check', type: item.type || 'regular', size: item.size }"
        :disabled="isDisabled"
        @onClick="iconHandler(item.handler)"
      /> -->
      <sprite
        v-for="(item,i) in iconsLeft"
        :key="i"
        :class="$style.svg"
        :name="item.name || 'check'"
        :size="item.size || 24"
        :type="item.type || 'regular'"
        color="#B2B2B2"
        @click.stop="iconHandler(item.handler)"
      />
    </div>
    <span
      v-if="prefix"
      :class="[$style.prefix, 'input-prefix']"
      @click.stop="handlePrefixClick"
    >
      {{ prefix }}
    </span>
    <input
      :id="getGpAutotestName"
      ref="input_field_icons"
      v-maska="mask"
      :data-testid="gpAutotestName || undefined"
      :value="componentValue"
      :readonly="readonly"
      :type="setInputType"
      :class="inputClasses"
      :style="size"
      :disabled="isDisabled || disabledInputOnly"
      :placeholder="placeholder ? placeholder : ''"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @keydown="onKeydownChange"
      @keyup="onKeyupChange"
      @blur="onBlur"
    >
    <span
      v-if="postfix"
      :class="$style.postfix"
      @click.stop="handlePostfixClick"
    >
      {{ postfix }}
    </span>
    <div
      v-if="iconsRight.length"
      :class="$style.icons_right"
    >
      <template v-if="showButton">
        <vgp-icon-button
          v-for="(item, i) in iconsRight"
          :key="i + item.name"
          size="small"
          :type="item.buttonType || 'simple'"
          :icon="{ name: item.name || 'check', type: item.type || 'regular', size: item.size }"
          :disabled="isDisabled"
          :data-testid="item.id || undefined"
          @onClick="iconHandler(item.handler)"
        />
      </template>
      <template v-else>
        <sprite
          v-for="(item,i) in iconsRight"
          :key="i"
          :class="$style.svg"
          :name="item.name || 'check'"
          :size="item.size || 24"
          :type="item.type || 'regular'"
          color="#B2B2B2"
          @click.stop="iconHandler(item.handler)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import vgpIconButton from '$$uiKitComp/globalButton/withIcon/iconButton.vue';
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  name: 'VgpInput',
  components: {
    vgpIconButton,
    sprite,
  },
  props: {
    gpAutotestName: { type: String, required: false, default: '' },
    autocomplete: {
      type: String,
      default: 'off',
    },
    placeholder: {
      type: [String, Number],
      required: false,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    disabledInputOnly: { type: Boolean, default: false },
    isError: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    iconsLeft: {
      type: Array,
      default: () => [],
    },
    iconsRight: {
      type: Array,
      default: () => [],
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    imagesLeft: {
      type: Array,
      default: () => [],
    },
    postfix: {
      type: String,
      default: null,
    },
    prefix: {
      type: String,
      default: null,
    },
    inputType: {
      type: String,
      required: false,
      default: 'text',
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
      required: false,
    },
    medium: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectByFocus: {
      type: Boolean,
      required: false,
    },
    blurOnEnter: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      required: false,
      default: true,
    },
    maxlength: {
      type: [String, Number],
      required: false,
      default: null,
    },
    min: {
      type: Number,
      required: false,
      default: null,
    },
    max: {
      type: Number,
      required: false,
      default: null,
    },
    mask: {
      type: String,
      default: '',
    },
    changeByEnter: {
      type: Boolean,
      default: false,
    },
    initialFocus: {
      type: Boolean,
      default: false,
    },
    inputSize: {
      type: String,
      default: '',
    },
    useTabKey: { type: Boolean, required: false, default: false },
    underline: { type: Boolean, default: false },
  },

  emits: {
    'update:modelValue': null,
    onChange: null,
    onBlur: null,
    onKeydown: null,
    onKeyup: null,
    onFocus: null,
    onClick: null,
  },
  data() {
    return {
      isFocus: false,
      isActive: false,
      componentValue: this.modelValue,
    };
  },

  computed: {
    getGpAutotestName() {
      if (this.gpAutotestName) return this.gpAutotestName;

      return `gp_autotest_input_${new Date().getTime()}`;
    },

    wrapperStyle() {
      if (this.inputSize) {
        return { height: this.inputSize, minHeight: this.inputSize };
      }

      return {};
    },

    size() {
      if (this.small && !this.inputSize) {
        return {
          height: '32px',
        };
      }
      if (this.inputSize) {
        return {
          height: this.inputSize,
        };
      }
      if (this.medium) {
        return {};
      }

      return {
        height: '40px',
      };
    },

    setInputType() {
      return this.inputType === 'number' ? 'text' : this.inputType;
    },
    inputBoxClasses() {
      const style = this.$style || {};

      return [
        'vgp-interactive-element',
        style.vgp_input_box,
        this.isError ? style.error : null,
        this.isActive ? style.active : null,
        this.isDisabled ? style.disabled : null,
        this.disabledInputOnly ? style.disabled_input : null,
        this.small ? style.small : (this.medium ? style.medium : style.big),
        this.underline ? style.underline : null,
        !this.border ? style.borderless : null,
        this.readonly ? style.borderless_readonly : null,
        this.postfix ? style.with_postfix : null,
        this.prefix ? style.with_prefix : null,
      ];
    },
    inputClasses() {
      const style = this.$style || {};

      return [style.vgp_input, this.useTabKey ? 'vgp_input_use_tab' : null, this.gpAutotestName || null];
    },
  },
  watch: {
    modelValue: {
      handler(v) {
        this.componentValue = v;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.initialFocus) {
      this.focusElement();
    }
  },

  methods: {
    focusInput() {
      this.$refs.input_field_icons.focus();
    },
    isNumberInput() {
      return this.inputType === 'number';
    },
    normalizeNumberInputValue(value) {
      let nextValue = value.replace(/[^\d.,\s]/g, '');

      nextValue = nextValue.replace(/,/g, '.');

      if (/\.\./.test(nextValue)) {
        nextValue = nextValue.replace(/\.\.+/g, '.');
      }

      return this.applyNumberBounds(nextValue);
    },
    applyNumberBounds(value) {
      if (this.max !== null && Number(value) > this.max) {
        return this.max;
      }

      if (this.min !== null && Number(value) < this.min) {
        return this.min;
      }

      return value;
    },
    normalizeNumberChangeValue(value) {
      if (value.length === 1 && value === '.') {
        return {
          value: value.slice(0, -1),
          shouldEmitCustomChange: false,
          shouldReturn: true,
        };
      }

      if (value.length > 2 && value.endsWith('.')) {
        return {
          value: value.slice(0, -1),
          shouldEmitCustomChange: true,
          shouldReturn: true,
        };
      }

      return {
        value,
        shouldEmitCustomChange: false,
        shouldReturn: false,
      };
    },
    focusElement() {
      this.focusInput();
      this.$emit('onClick');
    },

    onChange(e) {
      const value = e.target.value;

      if (this.isNumberInput()) {
        const { value: normalizedValue, shouldEmitCustomChange, shouldReturn } = this.normalizeNumberChangeValue(value);

        if (shouldReturn) {
          this.componentValue = normalizedValue;

          if (shouldEmitCustomChange) {
            this.$emit('onChange', { target: { value: normalizedValue } }, this.componentValue);
          }

          return;
        }
      }

      this.$emit('onChange', e, this.componentValue);
    },

    onInput(e) {
      let value = e.target.value;

      if (this.isNumberInput()) {
        value = this.normalizeNumberInputValue(value);
        e.target.value = value;
      }

      if (this.componentValue !== value) {
        this.componentValue = value;
        this.$emit('update:modelValue', value);
      }
    },

    onKeydownChange(e) {
      this.$emit('onKeydown', e, this.componentValue);
    },

    onKeyupChange(e) {
      if (e.key === 'Enter' && this.blurOnEnter) {
        this.$refs.input_field_icons.blur();
      }
      if (e.key !== 'Enter' && this.changeByEnter) return;

      this.$emit('onKeyup', e, this.componentValue);
    },

    onBlur(e) {
      this.$emit('onBlur', e, this.componentValue);
      const input = this.$refs.input_field_icons;

      if (input) {
        input.scrollLeft = 0;
      }
    },

    onFocus(e) {
      this.$emit('onFocus', e, this.componentValue);

      if (this.selectByFocus) {
        return e.target.select();
      }
    },

    iconHandler(handler) {
      this.focusInput();
      handler && handler();
    },

    handlePostfixClick() {
      this.focusInput();
    },
    handlePrefixClick() {
      this.focusInput();
    },
  },
};
</script>

<style module lang="less" src='./vInput.less'></style>
